import React from "react";
import Anchor from "../../HTMLEntities/Anchor";
import Card from "../../WidgetCard";
import {
    BannerCard,
    BannerCardBox,
    BannerCardWrapper,
    BannerContent,
    BannerLink,
    FastResponseIcon,
    TransparentProcessIcon,
    WideChoiceUnivIcon,
} from "./widgets/Styled";
import config from "../../../config/config";

class ApplyBanner extends React.Component {
    render() {
        return (
            <Card
                FindOutMore
                AutoMargin
                before={"''"}
                widgetCardStyle={{
                    mobile: {padding: "0", width: "90%", display: "block"},
                    laptop: {padding: "0", width: "85%", display: "block"},
                }}
                cardStyle={{mobile: {padding: "0"}, laptop: {padding: "0"}}}
            >
                <BannerCard>
                    <p>Overseas admission counseling from the comfort of home</p>
                    <BannerCardWrapper>
                        <BannerCardBox>
                            <TransparentProcessIcon />
                            <BannerContent>
                                <strong>Transparent Process</strong>
                                <p>Counseling that is student centric and data driven</p>
                            </BannerContent>
                        </BannerCardBox>
                        <BannerCardBox>
                            <WideChoiceUnivIcon />
                            <BannerContent>
                                <strong>Wide Choice of Universities</strong>
                                <p>Apply to 250+ Universities across 10+ Countries</p>
                            </BannerContent>
                        </BannerCardBox>
                        <BannerCardBox>
                            <FastResponseIcon />
                            <BannerContent>
                                <strong>Fast Response</strong>
                                <p>100% Online counselors are available on whatsapp, skype</p>
                            </BannerContent>
                        </BannerCardBox>
                    </BannerCardWrapper>
                    <BannerLink
                        onClick={() => {
                            window.location = `${config.SHIKSHA_STUDYABROAD_HOME}/apply`;
                        }}
                    >
                        <Anchor linkLabel="Learn More About Shiksha Counseling Service" />
                    </BannerLink>
                </BannerCard>
            </Card>
        );
    }
}
export default ApplyBanner;
